<template>
    <div class="okraina-block">
        <div class="block-title">Магазин не выбран</div>
        <div class="block-description">Для просмотра каталога товаров выберите ближайший к Вам магазин на карте</div>
        <br />
        <div class="btn btn1 slim" @click="goToHome">выбрать</div>
    </div>
</template>

<script>
export default {
    name: "okraina-retail-store-not-selected",

    methods: {

        /**
         * Переход на главный экрна
         */
        goToHome() {
            this.$router.push("/");

        }
    }
}
</script>